// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__XgxDO","spin":"styles_spin__25JVp"};